export const paneStyles = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  minWidth: 0,
  overflow: 'hidden',
};

export const paneHeaderStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '8px',
  padding: '8px 12px',
  borderBottom: ({ palette }) => `1px solid ${palette.divider}`,
};

export const paneTitleStyles = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const paneBodyStyles = {
  flex: 1,
  minHeight: 0,
  overflow: 'hidden',
};
